module.exports = __webpack_public_path__ + "img/9788961884952.994b1fd0.jpg";